<template>
  <div class="travel-wrapper">
    <!-- Professional Header -->
    <header class="travel-header">
      <div class="header-content">
        <!-- Brand Logo -->
        <router-link to="/" class="brand-logo">
          <img :src="logo" alt="PA Tours & Travels Logo" class="logo-icon" />
          <span class="brand-name">PA Tours & Travels</span>
        </router-link>

        <!-- Desktop Navigation -->
        <nav class="main-nav desktop-nav">
          <router-link 
            v-for="(item, index) in navItems" 
            :key="index"
            :to="item.navigateTo"
            class="nav-item"
            :class="{ 'active': isActiveRoute(item.navigateTo) }"
          >
            <div class="nav-icon" v-html="item.icon"></div>
            <span class="nav-label">{{ item.label }}</span>
          </router-link>
        </nav>

        <!-- Contact Us Button (Desktop) -->
        <!-- <button class="contact-btn desktop-contact" @click="goToContact">
          Contact Us
        </button> -->

        <!-- Mobile Menu Toggle -->
        <button class="mobile-menu-toggle" @click="toggleMobileMenu">
          <svg v-if="!mobileMenuOpen" viewBox="0 0 24 24" fill="currentColor">
            <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/>
          </svg>
          <svg v-else viewBox="0 0 24 24" fill="currentColor">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
          </svg>
        </button>
      </div>

      <!-- Mobile Menu Overlay -->
      <transition name="slide">
        <div v-if="mobileMenuOpen" class="mobile-menu" @click.self="closeMobileMenu">
          <div class="mobile-menu-content">
            <!-- Mobile Navigation -->
            <nav class="mobile-nav">
              <router-link 
                v-for="(item, index) in navItems" 
                :key="index"
                :to="item.navigateTo"
                class="mobile-nav-item"
                :class="{ 'active': isActiveRoute(item.navigateTo) }"
                @click.native="closeMobileMenu"
              >
                <div class="mobile-nav-icon" v-html="item.icon"></div>
                <span class="mobile-nav-label">{{ item.label }}</span>
                <svg class="arrow-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
                </svg>
              </router-link>
            </nav>

            <!-- Mobile Contact Button -->
            <!-- <button class="mobile-contact-btn" @click="goToContact">
              Contact Us
            </button> -->
          </div>
        </div>
      </transition>
    </header>
  </div>
</template>

<script>
export default {
  name: 'TravelHeader',
  data() {
    return {
      logo :require("../assets/img/logo33.png"),
      currentRoute: '/',
      mobileMenuOpen: false,
      navItems: [
        {
          label: 'Home',
          icon: `<svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
          </svg>`,
          navigateTo: '/'
        },
        {
          label: 'Flights',
          icon: `<svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"/>
          </svg>`,
          navigateTo: '/FlightDetails'
        },
        {
          label: 'Hotels',
          icon: `<svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-6c-1.1 0-2 .9-2 2v5H3V6H1v13h2v-3h18v3h2v-9c0-1.1-.9-2-2-2z"/>
          </svg>`,
          navigateTo: '/HotelDetails'
        },  
        {
          label: 'Holidays',
          icon: `<svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z"/>
          </svg>`,
          navigateTo: '/TourPackages'
        },
        {
          label: 'Cabs',
          icon: `<svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"/>
          </svg>`,
          navigateTo: '/Cabs'
        },
        {
          label: 'Packages',
          icon: `<svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 12c0-3 2.5-5.5 5.5-5.5S23 9 23 12H12zm0 0c0 3-2.5 5.5-5.5 5.5S1 15 1 12h11zm0 0c-3 0-5.5-2.5-5.5-5.5S9 1 12 1v11zm0 0c3 0 5.5 2.5 5.5 5.5S15 23 12 23V12z"/>
          </svg>`,
          navigateTo: '/OurTourPackages'
        }
      ]
    };
  },
  mounted() {
    this.currentRoute = this.$route.path;
    // Prevent body scroll when mobile menu is open
    this.$watch('mobileMenuOpen', (isOpen) => {
      if (isOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    });
  },
  beforeDestroy() {
    document.body.style.overflow = '';
  },
  watch: {
    '$route'(to) {
      this.currentRoute = to.path;
      this.mobileMenuOpen = false;
    }
  },
  methods: {
    isActiveRoute(path) {
      return this.currentRoute === path;
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false;
    },
    goToContact() {
      this.$router.push('/ContactUs');
      this.closeMobileMenu();
    }
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.travel-wrapper {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
}

/* Header - Professional Design */
.travel-header {
  position: sticky;
  top: 0;
  z-index: 1000;
  background: #ffffff;
  border-bottom: 1px solid #e0e0e0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.header-content {
  max-width: 1250px;
  margin: 0 auto;
  padding: 0 28px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
}

/* Brand Logo */
.brand-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  color: #000000;
  flex-shrink: 0;
  transition: opacity 0.3s ease;
  z-index: 2;
}

.brand-logo:hover {
  opacity: 0.7;
}

.logo-icon {
  width: 28px;
  height: 28px;
  color: #000000;
}

.brand-name {
  font-size: 20px;
  font-weight: 700;
  color: #000000;
  letter-spacing: -0.5px;
}

/* Desktop Navigation */
.main-nav {
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 1;
  justify-content: center;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  text-decoration: none;
  color: #666666;
  border-radius: 8px;
  transition: all 0.3s ease;
  cursor: pointer;
  background: transparent;
  position: relative;
}

.nav-item::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 2px;
  background: #000000;
  transition: width 0.3s ease;
}

.nav-item:hover {
  background: #f5f5f5;
  color: #000000;
}

.nav-item.active {
  color: #000000;
  font-weight: 600;
}

.nav-item.active::after {
  width: 80%;
}

.nav-icon {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.nav-icon svg {
  width: 20px;
  height: 20px;
  color: currentColor;
}

.nav-label {
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
}

/* Contact Button */
.contact-btn {
  padding: 10px 24px;
  background: #000000;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  flex-shrink: 0;
}

.contact-btn:hover {
  background: #2b2b2b;
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
}

/* Mobile Menu Toggle */
.mobile-menu-toggle {
  display: none;
  width: 40px;
  height: 40px;
  background: transparent;
  border: none;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  padding: 0;
  z-index: 2;
}

.mobile-menu-toggle svg {
  width: 24px;
  height: 24px;
  color: #000000;
}

/* Mobile Menu Overlay */
.mobile-menu {
  position: fixed;
  top: 64px;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  overflow-y: auto;
}

.mobile-menu-content {
  background: #ffffff;
  min-height: 100%;
  padding: 20px;
}

/* Mobile Navigation */
.mobile-nav {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 20px;
}

.mobile-nav-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  text-decoration: none;
  color: #333333;
  background: #fafafa;
  border-radius: 12px;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.mobile-nav-item:active {
  transform: scale(0.98);
}

.mobile-nav-item.active {
  background: #f0f0f0;
  color: #000000;
  border-color: #000000;
  font-weight: 600;
}

.mobile-nav-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.mobile-nav-icon svg {
  width: 24px;
  height: 24px;
  color: currentColor;
}

.mobile-nav-label {
  font-size: 16px;
  font-weight: 600;
  flex: 1;
}

.arrow-icon {
  width: 20px;
  height: 20px;
  color: #999999;
}

/* Mobile Contact Button */
.mobile-contact-btn {
  width: 100%;
  padding: 16px;
  background: #000000;
  color: #ffffff;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
}

.mobile-contact-btn:active {
  transform: scale(0.98);
}

/* Slide Transition */
.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease;
}

.slide-enter,
.slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* Responsive Design */
@media (max-width: 1024px) {
  .header-content {
    padding: 0 20px;
    gap: 20px;
  }

  .nav-item {
    padding: 8px 12px;
  }

  .nav-label {
    font-size: 13px;
  }
}

@media (max-width: 768px) {
  .header-content {
    height: 60px;
    padding: 0 16px;
  }

  .brand-name {
    font-size: 18px;
  }

  .logo-icon {
    width: 24px;
    height: 24px;
  }

  /* Hide desktop navigation */
  .desktop-nav,
  .desktop-contact {
    display: none;
  }

  /* Show mobile menu toggle */
  .mobile-menu-toggle {
    display: flex;
  }

  .mobile-menu {
    top: 60px;
  }
}

@media (max-width: 480px) {
  .brand-name {
    font-size: 16px;
  }

  .logo-icon {
    width: 22px;
    height: 22px;
  }

  .mobile-nav-item {
    padding: 14px;
  }

  .mobile-nav-label {
    font-size: 15px;
  }
}

/* Tablet Landscape */
@media (min-width: 769px) and (max-width: 1024px) {
  .nav-label {
    font-size: 12px;
  }

  .nav-item {
    padding: 8px 10px;
  }
}
</style>
